import React from "react";
import moment from "moment";
import { Button, Col, Dropdown, Row } from "react-bootstrap";

import { Calendar, Filter } from "react-feather";

const Header = () => {
  return (
    <Row className="mb-2 mb-xl-3">
      <Col xs="auto" className="d-block">
        <h3>Pregled oglasov za {moment().format("DD.MM.YYYY")}</h3>
      </Col>

      {/*<Col xs="auto" className="ms-auto text-end mt-n1">
        <Dropdown className="d-inline me-2">
          <Dropdown.Toggle variant="light" className="bg-white shadow-sm">
            <Calendar className="feather align-middle mt-n1" /> Danes
          </Dropdown.Toggle>
          <Dropdown.Menu>
            <Dropdown.Item>Včeraj</Dropdown.Item>
            <Dropdown.Item>Zadnjih 7 dni</Dropdown.Item>
            <Dropdown.Item>Zadnjih 30 dni</Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown>

        <Button variant="primary" className="shadow-sm me-1">
          <Filter className="feather" />
        </Button>
      </Col>*/}
    </Row>
  );
};

export default Header;
